import { ChevronRight, FileText } from "lucide-react";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { BetaMark } from "@/components/ui/beta/Beta";

/**
 * New visit with Voice to Text chosen: the way into radiology dictation
 * (dictate into a saved report template instead of recording a visit).
 */
export const DictationReportEntryV32 = ({
  onOpen,
}: {
  onOpen: () => void;
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <button
      className="flex w-full min-w-0 items-center gap-3 rounded-[14px] bg-v3-panel p-3.5 text-left font-v3 shadow-v3-hairline-strong transition-colors hover:bg-v3-surface-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-v3-brand-ring"
      data-testid="dictation-report-entry"
      type="button"
      onClick={onOpen}
    >
      <span
        aria-hidden
        className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-v3-brand-tint text-v3-brand [&_svg]:size-5"
      >
        <FileText />
      </span>
      <span className="min-w-0 flex-1">
        {/* The Beta pill follows the title, also when the title wraps. */}
        <span className="block text-[15px] font-semibold leading-[22px] text-v3-text">
          {t("dictationReport.entry.title")}
          <BetaMark
            className="ml-2 inline-flex translate-y-[-1px] align-middle"
            feature="radiology-dictation"
          />
        </span>
        <span className="block text-[13.5px] leading-5 text-v3-text-3">
          {t("dictationReport.entry.hint")}
        </span>
      </span>
      <ChevronRight aria-hidden className="size-5 shrink-0 text-v3-text-3" />
    </button>
  );
};
